<template>
  <div>
    <McButton
      variant="primary"
      :icon="transitionMappings[status].buttonIcon"
      :text="transitionMappings[status].buttonText"
      :disabled="isLoading"
      @click="$bvModal.show('modal-scheduler-transition')"
    />

    <b-modal
      class="mc-modal"
      id="modal-scheduler-transition"
      ref="modal-scheduler-transition"
      size="md"
      centered
      scrollable
      :title="transitionMappings[status].modalTitle"
    >
      <div class="card-body p-2 d-flex flex-column gap-2">
        <template v-for="text in transitionMappings[status].textHTML">
          <div v-html="text" />
        </template>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex mx-0 gap-2">
          <McButton
            variant="secondary"
            :text="$t('global.action.cancel')"
            :disabled="isSubmitting"
            @click="cancel()"
          />
          <McButton
            variant="primary"
            :text="transitionMappings[status].okText"
            :disabled="isSubmitting"
            @click="handleTransition"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import McButton from '@/components/McButton'
import * as DeliveryScheduler from '@/services/rest-api/lib/scheduler/scheduler'

export default {
  components: {
    McButton,
  },
  props: {
    status: {
      type: String,
      default: 'Aktif',
    },
    name: {
      type: String,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    errorResponse: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['update:isLoading', 'show-data', 'assign-error'],
  data() {
    return {
      isSubmitting: false,
    }
  },
  computed: {
    transitionMappings() {
      return {
        Aktif: {
          buttonText: 'Nonaktifkan',
          buttonIcon: 'icon-outline_slash',
          modalTitle: 'Nonaktifkan Penjadwalan',
          transitionTo: 'INACTIVE',
          okText: 'Ya, Nonaktifkan',
          toastText: 'Penjadwalan berhasil dinonaktifkan.',
          textHTML: [
            `<span>Apakah Anda yakin ingin menonaktifkan penjadwalan <strong>${this.name}</strong>?</span>`,
            `<span>Penjadwalan akan berhenti dijalankan oleh sistem.</span>`,
          ],
        },
        'Tidak Aktif': {
          buttonText: 'Aktifkan',
          buttonIcon: 'icon-outline_checkmark',
          modalTitle: 'Aktifkan Penjadwalan',
          transitionTo: 'ACTIVE',
          okText: 'Ya, Aktifkan',
          toastText: 'Penjadwalan berhasil diaktifkan.',
          textHTML: [
            `<span>Apakah Anda yakin ingin mengaktifkan penjadwalan <strong>${this.name}</strong>?</span>`,
            `<span>Penjadwalan akan dijalankan kembali oleh sistem.</span>`,
          ],
        },
        'Gagal Dijalankan': {
          buttonText: 'Aktifkan Kembali',
          buttonIcon: 'icon-outline_checkmark',
          modalTitle: 'Aktifkan Penjadwalan',
          transitionTo: 'ACTIVE',
          okText: 'Ya, Aktifkan',
          toastText: 'Penjadwalan berhasil diaktifkan.',
          textHTML: [
            `<span>Apakah Anda yakin ingin mengaktifkan penjadwalan <strong>${this.name}</strong>?</span>`,
            `<span>Penjadwalan akan dijalankan kembali oleh sistem.</span>`,
          ],
        },
      }
    },
  },
  methods: {
    async handleTransition() {
      if (this.isLoading || this.isSubmitting) return

      if (this.errorResponse?.code?.includes('ERR_EXPIRED_SCHEDULER')) {
        this.$mcToast.error('Penjadwalan gagal dijalankan. Perulangan belum diperbarui.')
        this.$bvModal.hide('modal-scheduler-transition')
        return
      }

      this.isSubmitting = true
      this.$emit('update:isLoading', true)

      const data = {
        status: this.transitionMappings[this.status].transitionTo,
      }

      const res = await DeliveryScheduler.transition(this.$route.params.id, data)

      if (res.errors) {
        if (res.errors.templates) {
          this.$mcToast.error('Gagal diaktifkan. Ada kesalahan pada template.')
          this.$emit('assign-error', res.errors)
        } else {
          this.$mcToast.error('Terdapat kesalahan pada input Anda')
        }

        this.$bvModal.hide('modal-scheduler-transition')
        this.isSubmitting = false
        this.$emit('update:isLoading', false)

        return
      }

      this.$mcToast.success(this.transitionMappings[this.status].toastText)
      this.$bvModal.hide('modal-scheduler-transition')
      this.isSubmitting = false
      this.$emit('update:isLoading', false)

      this.$emit('show-data')
    },
  },
}
</script>
